import { FC } from 'react';
import styled, { css } from 'styled-components';

import { ReactComponent as BankIcon } from '@/assets/icons/bank.svg';
import { ReactComponent as PayoneerIcon } from '@/assets/icons/payoneer.svg';
import { ReactComponent as PaypalIcon } from '@/assets/icons/paypal.svg';
import { PaymentMethod } from '@/utils/enums';

const markStyles = css`
  flex-shrink: 0;
  margin-right: 6px;
`;

// Receiver rows key off the details a member has on file (they can hold all
// three at once), so the marks are exported individually as well.
export const BankMark = styled(BankIcon)`
  ${markStyles}
`;

export const PaypalMark = styled(PaypalIcon)`
  ${markStyles}
`;

export const PayoneerMark = styled(PayoneerIcon)`
  ${markStyles}
`;

const marks = {
  [PaymentMethod.Bank]: BankMark,
  [PaymentMethod.Paypal]: PaypalMark,
  [PaymentMethod.Payoneer]: PayoneerMark,
};

interface Props {
  method: PaymentMethod;
}

const PaymentMethodIcon: FC<Props> = ({ method }) => {
  const Mark = marks[method] ?? BankMark;

  return <Mark />;
};

export default PaymentMethodIcon;
